/** Shared GraphQL field fragments for cadence queries. */

export const CADENCE_FIELDS = `
  id
  referenceId
  oid
  name
  description
  cadenceType
  isTemplate
  ownerUserId
  status
  version
  scheduledSendDate
  scheduledSendTimezone
  startedAt
  pausedAt
  createdByUserId
  updatedByUserId
  createdAt
  updatedAt
  canView
  canEdit
  canDelete
  displayStatus
  displayStatusLabel
  availableActions
  tags
  savedSearchTagId
  savedSearchSyncConfig
  sourceCadenceTemplateId
  totalMembers
  numberOfSteps
  templateUsageCount
  respectBlackoutDates
  singleEnrollmentOnly
  enrollmentLocked
  pausedReason
  senderEmail
  senderName
  replyToEmail
  replyToEmails
  audiences {
    id
    audienceType
    contactListId
    contactId
    savedSearchTagId
    autoAddEnabled
  }
`;

export const AUTO_REMOVAL_RULE_FIELDS = `
  id
  cadenceId
  removalType
  removalConfig
  priority
  cadenceEventId
  terminalEvent {
    id
    eventType
    eventConfig
    isAutomated
  }
  createdAt
`;

export const SUCCESS_METRIC_FIELDS = `
  id
  cadenceId
  metricType
  targetPercentage
  metricConfig
  priority
  priorityOrder
  cadenceEventId
  terminalEvent {
    id
    eventType
    eventConfig
    isAutomated
  }
  createdAt
`;

export const CADENCE_EVENT_FIELDS = `
  id
  referenceId
  cadenceId
  sequenceOrder
  eventType
  isAutomated
  emailTemplateId
  isActive
  eventConfig
  stepLabel
  cadenceEventReferenceNumber
  createdAt
  updatedAt
`;

export const CADENCE_EDGE_FIELDS = `
  id
  fromCadenceEventId
  toCadenceEventId
  edgeType
`;

export const CADENCE_MEMBER_FIELDS = `
  id
  cadenceId
  contactId
  email
  audienceId
  enrolledAt
  enrolledByUserId
  enrollmentSource
  status
  currentEventId
  isSuccessful
  successAchievedAt
  removedAt
  removedByUserId
  removalReason
  removalDetails
  completedAt
  totalEventsReceived
  totalEmailsSent
  totalEmailsDelivered
  totalEmailsOpened
  totalEmailsClicked
  totalEmailsReplied
  totalEmailsBounced
  totalInteractions
  totalProposals
  displayStatus
  statusExplanation
  derivedDelivered
  emailsAttempted
  nextEventScheduledAt
  createdAt
  updatedAt
  failureEvents {
    id
    failureType
    failureReason
    failureDetails
    triggeredAt
    cadenceEventId
  }
`;
